import React from "react";
import { MessageCircle } from "lucide-react";
import { contact } from "../mock";

// An image wrapped in a WhatsApp link with a neon theme treatment and a
// hover "Chat on WhatsApp" badge. Clicks are auto-tracked by AnalyticsTracker
// because the href contains the WhatsApp URL.
const WhatsAppImage = ({
  src,
  alt,
  className = "",
  imgClassName = "",
  rounded = "rounded-2xl",
  label = "Chat on WhatsApp",
  plain = false,
}) => {
  return (
    <a
      href={contact.whatsapp}
      target="_blank"
      rel="noreferrer"
      aria-label={label}
      className={`img-neon group relative block overflow-hidden ${rounded} ${className}`}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${imgClassName}`}
      />
      {!plain && <span className="img-neon-tint" />}
      {!plain && <span className="img-neon-vignette" />}
      <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] text-white text-sm font-semibold shadow-lg translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
          <MessageCircle size={16} /> {label}
        </span>
      </span>
    </a>
  );
};

export default WhatsAppImage;
